import { useQuery } from 'react-query'

import axiosInstance from 'api/axiosInstance'
import { type Response } from 'api/types/Response'

export type ReferralInfo = {
  message: {
    balance: number
    code: string
    referred_fan_count: number
    referred_creator_count: number
  }
}

export const useReferralsInfo = () => {
  const getReferralInfoData = async (): Promise<ReferralInfo> => {
    const { data: res } = await axiosInstance.get<Response<ReferralInfo>>('/api/user/referral/info')

    return res.data
  }

  return useQuery(['referrals-info'], getReferralInfoData)
}